import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IonAccordion, IonAccordionGroup, PopoverController } from '@ionic/angular';
import { BolsaService } from '../../services/bolsa.service';
import { DirectorioService } from 'src/app/directorio/servicios/directorio.service';

@Component({
  selector: 'app-filtro-ubicacion',
  templateUrl: './filtro-ubicacion.component.html',
  styleUrls: ['./filtro-ubicacion.component.scss'],
})
export class FiltroUbicacionComponent implements OnInit {
  @Input() multi = false;

  locationForm: UntypedFormGroup

  countries: any[] = [];
  selectedCountry: any;

  cities: any[] = [];
  selectedCity: any;
  
  sectors: any[] = [];
  selectedSector: any;

  countryId = undefined;

  constructor( 
    private bolsaSv: BolsaService,
    private popoverController: PopoverController,
    private fb: UntypedFormBuilder,
    private directorioSv: DirectorioService,
  ) { }

  async ngOnInit() {
    this.locationForm = this.fb.group({
      countryId: [''],
      cityId: [''],
      sectorId: ['']
    });

    this.countries = await this.bolsaSv.getCountries();
    this.countryId = Number(localStorage.getItem('countryId')) || 1;
    await this.setCities({ detail: { value: this.countryId } });
    const values = {};
    for(const key of Object.keys(this.locationForm.value)){
      const value = Number(localStorage.getItem(key));
      values[key] = value;
      if(!!value){
        values[key] = value;
      };
    };
    this.locationForm.patchValue(values);
  }

  async getActualLocation(){
    const country = await this.bolsaSv.getActualLocation();
    let savedCountry = localStorage.getItem('country');
    if(!savedCountry){
      // this.storageService.set('country', country);
      const value = {
        detail: {value: country}
      }
      this.setCities(value);
    }
  }

  async setCities(ev, country?: IonAccordion){
    try{
      const id = ev.detail.value;
      this.selectedCountry = this.countries.find(country => {
        if(country.id === id){
          return country
        }else if(country.name === id){
          return country
        }
      });
      if(this.selectedCountry){
        this.cities = await this.bolsaSv.getCities(this.selectedCountry.id);
        if(this.countryId !== id){
          this.locationForm.get('cityId').setValue('');
          this.locationForm.get('sectorId').setValue('');
        }
      }
    }catch (err){
      console.log(err);
    }
  }

  async setSectors(ev, state: IonAccordion){
    try{
      const id = ev.detail.value;
      if(id){
        this.selectedCity = this.cities.find(city => city.id === id);
        this.sectors = await this.bolsaSv.getSectors(id);
      }else{
        this.selectedCity = '';
      }
    }catch(err){
      console.log(err);
    }
  }

  async setSector(ev, city){
    const id = ev.detail.value;
    if(id){
      this.selectedSector = this.sectors.find(sector => sector.id === id);
    }
  }

  async closeLocation(){
    await this.popoverController.dismiss();
  }

  async saveLocation(){
    const location = {
      country: this.selectedCountry,
      city: this.selectedCity,
      sector: this.selectedSector,
    }

    if(this.multi){
      await this.popoverController.dismiss(location);
      return true;

    }

    for(const key of Object.keys(this.locationForm.value)){
      localStorage.setItem(key, String(this.locationForm.value[key]));
    }
    
    if(!location.country.name){
      localStorage.removeItem('cityId');
      localStorage.removeItem('sectorId');
      localStorage.removeItem('countryId');
      localStorage.removeItem('city');
      localStorage.removeItem('sector');
    }
    this.directorioSv.citiesSource.next();
    await this.popoverController.dismiss(location);
  }

}
